export default __webpack_public_path__ + "static/scams-hub-jul-sep-2024-hero-6ed42baaed771923078c4ea48d265687.webp";